/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Terms_Delete_Terms_TextInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete {count} term(s)? This action cannot be undone." |
*
* @param {Knp_Terms_Delete_Terms_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_delete_terms_text = /** @type {((inputs: Knp_Terms_Delete_Terms_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Delete_Terms_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Voulez-vous vraiment supprimer ${i?.count} terme(s) ? Cette action est irréversible.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Sind Sie sicher, dass Sie den/die Begriff(e) ${i?.count} löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Vuoi davvero eliminare ${i?.count} termini? Questa azione non può essere annullata.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить термин(ы) ${i?.count}? Это действие необратимо.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Seguro que desea eliminar ${i?.count} términos? Esta acción no se puede deshacer.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`您确定要删除${i?.count}项吗？此操作无法撤销。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 個の用語を削除してもよろしいですか? この操作は元に戻せません。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्या आप वाकई ${i?.count} शब्द हटाना चाहते हैं? यह कार्रवाई पूर्ववत नहीं की जा सकती।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir o(s) termo(s) ${i?.count}? Esta ação não pode ser desfeita.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete ${i?.count} term(s)? This action cannot be undone.`)
});